import React from 'react';

import { Button } from 'common/components';
import { MAIN_ROUTES } from 'common/config';
import { ButtonSize } from 'common/enums';

import './Unauthorized.scss';

const Unauthorized = () => {
    const handleNavigation = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = MAIN_ROUTES.HOME;
    };

    return (
        <div className="unauthorized-container">
            <div className="unauthorized-content-area">
                <h1 className="unauthorized-code">401</h1>
                <h4>Access Denied!</h4>
                <hr className="unauthorized-separator" />
                <div className="unauthorized-description">
                    You don&apos;t have access to this page.
                    <div>Please try again.</div>
                </div>
                <Button
                    className="unauthorized-button"
                    size={ButtonSize.Small}
                    onClick={handleNavigation}>
                    Go back to home
                </Button>
            </div>
        </div>
    );
};

export default Unauthorized;
